import { type TaxPreparationStepProps } from "../components/TaxPreparationStep";

export function getTaxPreparationSteps(params: {
  taxationYear: number;
}): TaxPreparationStepProps[] {
  const { taxationYear } = params;

  return [
    {
      title: "Update your information in Stripe",
      subtitle: `Due by December 31, ${taxationYear}`,
      description:
        "Stripe will send you an email asking to you make sure your SSN, email, and mailing address are all correct so your forms are sent to the right place.",
    },
    {
      title: "Opt in to electronic delivery",
      subtitle: `Due by December 31, ${taxationYear}`,
      description:
        "In the email you receive from Stripe, you will also need to opt in to electronic delivery.",
    },
    {
      title: "Retrieve your 1099-NEC from Stripe",
      subtitle: `Due by January 31, ${taxationYear + 1}`,
      description:
        "1099-NEC forms will be available in your Stripe account by January 31st. You will also receive an email with this form.",
    },
  ];
}
